require('./bootstrap')

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCarousel from 'vue-carousel'
import VModal from 'vue-js-modal'
import Viewer from 'v-viewer'

Vue.router = router
Vue.use(VueAxios, axios)

Vue.use(VueCarousel)
Vue.use(VModal)
Vue.use(Viewer)

Vue.use(VueAuth, {
  auth: {
    request (req, token) {
      token = JSON.parse(token)

      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token.access_token})
    },
    response (res) {
      if (res.data && res.data.access_token) {
        return JSON.stringify(res.data)
      }
    }
  },
  _tokenExpired () {
    debugger

  },
  _invalidToken (res, transition) {
    debugger
    if (res.status === 401) {
      return true
    }
  },
  tokenDefaultName: 'auth_token',
  tokenOtherName: 'auth_token',
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: process.env.MIX_APP_URL + '/oauth/token',
    method: 'POST',
    data: {
      grant_type: 'password',
      client_id: process.env.MIX_CLIENT_ID,
      client_secret: process.env.MIX_CLIENT_KEY,
    },
    fetchUser: true
  },
  fetchData: {
    url: 'api/user',
    method: 'GET',
    enabled: true
  },
  refreshData: {
    url: process.env.MIX_APP_URL + '/oauth/token',
    method: 'POST',
    data: {
      grant_type: 'refresh_token',
      refresh_token: localStorage.getItem('auth_token') ? JSON.parse(localStorage.getItem('auth_token')).refresh_token : null,
      client_id: process.env.MIX_CLIENT_ID,
      client_secret: process.env.MIX_CLIENT_KEY,
    },
    enabled: true,
    interval: 1
  },
})

// Enable devtools
Vue.config.devtools = true

sync(store, router)

const {state} = store


router.beforeEach((route, redirect, next) => {
  if (state.app.device.isMobile && route.name !== 'Mobile') {
    next({name: 'Mobile'})
  } else{
    next()
  }
})

const app = new Vue({
  router,
  store,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./resources/assets/js/app.js